import { LoginService } from './../login.service';
import { SettingsService } from './../settings.service';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    standalone: false
})
export class SearchComponent implements OnInit {
  startDate
  endDate
  searchType='deleted'
  deletedAppointments=null
  constructor(public settingsService:SettingsService,public ls:LoginService ,private datePipe: DatePipe,private translate: TranslateService){ }

  ngOnInit(): void {
    this.startDate = moment().startOf('day')
    this.endDate = moment().endOf('day')
  }


  onStartDateChange(date: Date) {
    
    console.log('Start date changed:', this.startDate);
   
  }
// when user pick a date to end search
  onEndDateChange(date: Date) {
    console.log('End date changed:',  date);
   
  }

  search(){
    let adjustedStartDate = moment(this.startDate).startOf('day').toISOString();
    let adjustedEndDate = moment(this.endDate).endOf('day').toISOString();
    const appointmentsByRooms=this.ls?.premissions?.ApptsByRoom
    this.settingsService.search(this.searchType,adjustedStartDate,adjustedEndDate,appointmentsByRooms?null:this.ls.doctor).subscribe({
      next: (data) => {
        this.deletedAppointments=data
        
      },
      error: (err) => this.deletedAppointments=[]
    })


  }

  
  getTranslatedExamType(examType: string): string {
    const translationKey = `appointments.gui.exams.${examType}`;
    const translated = this.translate.instant(translationKey);
    return translated === translationKey ? examType : translated;
  }
  exportExcel() {
    let appointmentsByRooms = this.ls?.premissions?.ApptsByRoom;
    let data = this.deletedAppointments.map((appointment) => {
      const date=this.datePipe.transform(appointment.aptTime, 'dd/MM/yyyy HH:mm')
      let appointmentData = {
        "Appointment": this.getTranslatedExamType(appointment.examType),
        "Date": date,
        "Exam Type": appointment.examType,
        "Patient Name": `${appointment.First} ${appointment.Last}`,
        "Patient ID": appointment.ID
      };
      if (!appointmentsByRooms) {
        appointmentData["Doctor"] = appointment.Name;
      }
  
      return appointmentData;
    });
  
    const sheetName = 'Report';
  
    const formattedStartDate = this.startDate.format('DD/MM/YYYY'); 
    const formattedEndDate = this.endDate.format('DD/MM/YYYY');     
    const fileName = `report deleted appointments from ${formattedStartDate} to ${formattedEndDate}.xlsx`;
  
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    XLSX.writeFile(workbook, fileName);
  }
  

}
